import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routesToRedirect = [
	{ name: 'cursos', params: { key: 'tipo', values: ['graduacao'] }, query: { key: 'tag', values: ['engenharia'] }, to: '//vestibular.fael.edu.br/nossos-cursos/engenharia-e-arquitetura/32' },
	{ name: 'cursos', params: { key: 'tipo', values: ['saude'] }, to: '//vestibular.fael.edu.br/nossos-cursos/carreiras-em-saude/36' },
	{ name: 'cursos', params: { key: 'tipo', values: ['graduacao-presencial'] }, to: '//graduacao.fael.edu.br' },
	{ name: 'cursos', params: { key: 'tipo', values: ['pos-graduacao'] }, to: '//posead.fael.edu.br' },
	{ name: 'cursos', params: { key: 'tipo', values: ['graduacao'] } },
	{ name: 'transferencia-e-aproveitamento', to: '//conheca.fael.edu.br/ingresso' },
	{ name: 'vestibular' }
]

const beforeEnterRedirect = (to, from, next) => {
	let routeToRedirect = routesToRedirect.find(item => {
		if (item.params == undefined && item.query == undefined)
			return item.name == to.name
		else if (item.query) {
			if (to.query[item.query.key] != undefined)
				return item.name == to.name && item.params.values.includes(to.params[item.params.key]) && item.query.values.includes(to.query[item.query.key])
		} else {
			return item.name == to.name && item.params.values.includes(to.params[item.params.key])
		}
	})
	
	if (routeToRedirect != undefined) {
		const redirectTo = routeToRedirect.to || '//vestibular.fael.edu.br'
		if (from.name == null)
			return window.location.replace(redirectTo)
		window.open(redirectTo, '_blank')
		return next(false)
	}
	next()
}

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import( /* webpackChunkName: "home" */ './views/Home/Home.vue')
	},
	{
		path: '/cursos/:tipo',
		name: 'cursos',
		component: () => import( /* webpackChunkName: "cursos" */ './views/Cursos/Cursos.vue'),
		beforeEnter: beforeEnterRedirect,
	},
	{
		path: '/cursos/:tipo/:slug',
		name: 'curso',
		component: () => import( /* webpackChunkName: "curso" */ './views/Curso/Curso.vue'),
		beforeEnter: beforeEnterRedirect,
	},
	{
		path: '/vestibular',
		name: 'vestibular',
		component: () => import( /* webpackChunkName: "vestibular" */ './views/Vestibular/Vestibular.vue'),
		beforeEnter: beforeEnterRedirect,
	},
	{
		path: '/pos-conteudo-gratuito',
		name: 'ead40',
		component: () => import( /* webpackChunkName: "ead40" */ './views/Ead40/Ead40.vue')
	},
	{
		path: '/jornada-de-extensao',
		name: 'jornada-de-extensao',
		component: () => import( /* webpackChunkName: "jornadaDeExtensao" */ './views/JornadaDeExtensao/JornadaDeExtensao.vue')
	},
	{
		path: '/cursos-gratuitos',
		name: 'cursos-gratuitos',
		component: () => import( /* webpackChunkName: "cursosGratuitos" */ './views/CursosGratuitos/CursosGratuitos.vue')
	},
	{
		path: '/unidades/:uf?/:cidade?',
		name: 'unidades',
		component: () => import( /* webpackChunkName: "unidades" */ './views/Unidades/Unidades.vue'),
		beforeEnter: (to, from, next) => {
			if (to.params.uf)
				to.params.uf = to.params.uf.toUpperCase()
			next()
		}
	},
	{
		path: '/transferencia-e-aproveitamento',
		name: 'transferencia-e-aproveitamento',
		component: () => import( /* webpackChunkName: "transferenciaEAproveitamento" */ './views/TransferenciaEAproveitamento/TransferenciaEAproveitamento.vue'),
		beforeEnter: beforeEnterRedirect,
	},
	{
		path: '/bolsas-e-descontos',
		name: 'bolsas-e-descontos',
		component: () => import( /* webpackChunkName: "BolsasEdescontos" */ './views/BolsasEdescontos/BolsasEdescontos.vue')
	},
	{
		path: '/institucional/certificacoes/registro-de-diploma',
		name: 'registro-de-diploma',
		component: () => import( /* webpackChunkName: "registroDeDiploma" */ './views/RegistroDeDiploma/RegistroDeDiploma.vue')
	},
	{
		path: '/faq',
		name: 'faq',
		component: () => import( /* webpackChunkName: "faq" */ './views/Faq/Faq.vue')
	},
	{
		path: '/convenios',
		name: 'convenios',
		component: () => import( /* webpackChunkName: "convenios" */ './views/Convenios/Convenios.vue')
	},
	{
		path: '/noticias',
		name: 'noticias',
		component: () => import( /* webpackChunkName: "noticias" */ './views/Noticias/Noticias.vue')
	},
	{
		path: '/noticias/:slug',
		name: 'noticia',
		component: () => import( /* webpackChunkName: "noticia" */ './views/Noticia/Noticia.vue')
	},
	{
		path: '/institucional/depoimentos',
		alias: '/depoimentos',
		name: 'depoimentos',
		component: () => import( /* webpackChunkName: "depoimentos" */ './views/Depoimentos/Depoimentos.vue')
	},
	{
		path: '/egressos/beneficios',
		name: 'egressosBeneficios',
		component: () => import( /* webpackChunkName: "egressosBeneficios" */ './views/EgressosBeneficios/EgressosBeneficios.vue')
	},
	{
		path: '/egressos/desenvolvimento-de-carreira',
		name: 'egressosDesenvolvimentoDeCarreira',
		component: () => import( /* webpackChunkName: "egressosDesenvolvimentoDeCarreira" */ './views/EgressosDesenvolvimentoDeCarreira/EgressosDesenvolvimentoDeCarreira.vue')
	},
	{
		path: '/egressos/:slug?/:other_slug?',
		name: 'egressos',
		component: () => import( /* webpackChunkName: "egressos" */ './views/Egressos/Egressos.vue')
	},
	{
		path: '/prouni',
		name: 'prouniHome',
		component: () => import( /* webpackChunkName: "prouniHome" */ './views/ProuniHome/Pagina.vue')
	},
	{
		path: '/prouni/formulario',
		name: 'prouniFormulario',
		component: () => import( /* webpackChunkName: "prouniFormulario" */ './views/ProuniFormulario/Pagina.vue')
	},
	{
		path: '/prouni/:slug?',
		name: 'prouni',
		component: () => import( /* webpackChunkName: "prouni" */ './views/Prouni/Pagina.vue')
	},
	// {
	// 	path: '/portal-do-aluno',
	// 	name: 'RedirectPortal',
	// 	component: () => import( /* webpackChunkName: "RedirectPortal" */ './views/RedirectPortal/RedirectPortal.vue')
	// },
	{
		path: '/*',
		name: 'pagina',
		component: () => import( /* webpackChunkName: "pagina" */ './views/Pagina/Pagina.vue')
	},
]

routes.push({
	path: '/*',
	name: '404',
	alias: '*',
	component: () => import( /* webpackChunkName: "404" */ './views/404/404.vue')
})

export default new Router({
	mode: 'history',
	base: '',
	routes,
	// eslint-disable-next-line
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})
